:host {
  @include reset-host;
}

:host .header {
  @include z-index('header');
  position: relative;

  padding: rem(27) $gutter;

  background: $white;

  @include mq('max', 'md') {
    padding: rem(16) $gutter-mobile;
  }
}

:host .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 90vw;
  margin: 0 auto;
}
